export default {
    active: true,
    seed: 11,
    skyType: "gradient",
    skyColor: "#000000",
    horizonColor: "#000000",
    lighting: "distant",
    lightPosition: { x: 0.5, y: 1, z: 0 },
    fog: 0.8,
    flatShading: true,
    playArea: 1,
    ground: "canyon",
    groundYScale: 9.76,
    groundTexture: "walkernoise",
    groundColor: "#D1D1D1",
    groundColor2: "#494949",
    dressing: "stones",
    dressingAmount: 500,
    dressingColor: "#494949",
    dressingScale: 0.06,
    dressingVariance: { x: 0.2, y: 0.1, z: 0.2 },
    dressingUniformScale: true,
    dressingOnPlayArea: 1,
    grid: "none",
    gridColor: "#239893",
    shadow: false,
};
